console.log("ExamTrack UI loaded");

//const STORAGE_KEY = "examtrack:selected";

export default async function initExamTrack() {
  console.log("initExamTrack running");

  const container = document.querySelector("[data-examtrack]");
  if (!container) {
    console.warn("ExamTrack container not found");
    return;
  }

  try {
    const endpoint =
      window.EXAMTRACK_API || "/examtrack-data/final/exam-timetable.json";

    console.log("ExamTrack endpoint:", endpoint);

    const res = await fetch(endpoint, { cache: "no-store" });

    if (!res.ok) {
      throw new Error(`Failed to load ${endpoint} (${res.status})`);
    }

    const data = await res.json();

    render(container, data);
  } catch (err) {
    console.error("ExamTrack error:", err);
    container.innerHTML = `<p>Failed to load exam timetable.</p>`;
  }
}

function render(el, data) {
  const { exams, status, meta } = data;
  //const isPreview = window.EXAMTRACK_API === "examtrack-data.php";
  const isPreview =
    window.EXAMTRACK_API && window.EXAMTRACK_API.includes("examtrack-data.php");

  // --- state
  let selected = getFromQuery();

  // ensure still valid
  let suggestions = [];
  let activeIndex = -1;

  el.innerHTML = `
    <div class="examtrack-ui">
       ${
         isPreview
           ? `
  <div class="examtrack-ui__mode examtrack-ui__mode--preview">
    👁 Preview mode — using unpublished runtime data
    <a href="index.php" class="btn btn--outline examtrack-ui__back"> Back</a>
  </div>
`
           : ``
       }

      <div class="examtrack-ui__controls">

        <p class="examtrack-ui__hint">
          Enter at least 6 characters of your module code, then select the module you want to add. After adding one module, you can search again to add another.
        </p>

        <div class="examtrack-ui__actions">

          <button type="button" class="btn btn--solid examtrack-ui__copy" disabled>
            <i class="bi bi-link-45deg" aria-hidden="true"></i>
            Copy link
          </button>
        
          <button type="button" class="btn btn--solid examtrack-ui__copy-table" disabled>
            <i class="bi bi-clipboard" aria-hidden="true"></i>
            Copy timetable
          </button>
        
        </div>

        <p class="examtrack-ui__add-more-hint" hidden>
          Need to add another exam? Search again using the box below.
        </p>

        <div class="examtrack-ui__tags" aria-live="polite"></div>

        <div class="examtrack-ui__searchwrap">
          <input 
            type="text" 
            placeholder="Enter module code…"
            class="examtrack-ui__search"
            aria-autocomplete="list"
            aria-expanded="false"
            aria-controls="examtrack-suggestions"
          />
          <button type="button" class="examtrack-ui__clear" title="Clear selection">
            Clear
          </button>
        </div>

        <ul id="examtrack-suggestions" class="examtrack-ui__suggestions" role="listbox"></ul>

      </div>

    <div class="examtrack-ui__results" hidden>

      <h2 id="examtrack-timetable-heading">My Exam Timetable</h2>
      <p class="examtrack-ui__status">
        Your personalised exam timetable is shown below.
      </p>

      <p>${status.description}</p>

      ${
        !isPreview
          ? `
            <p class="examtrack-ui__meta">
              Last updated: ${formatDate(meta.deployedAt)}
            </p>
            `
          : ""
      }


      <div
        class="examtrack-ui__table-scroll"
        role="region"
        aria-labelledby="examtrack-timetable-heading"
        tabindex="0"
      >
        <table class="examtrack-ui__table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Time</th>
              <th>Code</th>
              <th>Module Title</th>
              <th>Type</th>
              <th>Location</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>

      <p class="examtrack-ui__empty">
        Enter your module code and select a module to view your exams.
      </p>

    </div>
  `;

  const tbody = el.querySelector("tbody");
  const input = el.querySelector(".examtrack-ui__search");
  const suggestionsEl = el.querySelector(".examtrack-ui__suggestions");
  const tagsEl = el.querySelector(".examtrack-ui__tags");
  const addMoreHint = el.querySelector(".examtrack-ui__add-more-hint");
  const clearBtn = el.querySelector(".examtrack-ui__clear");
  const empty = el.querySelector(".examtrack-ui__empty");
  const resultsEl = el.querySelector(".examtrack-ui__results");
  const copyBtn = el.querySelector(".examtrack-ui__copy");
  const copyTableBtn = el.querySelector(".examtrack-ui__copy-table");

  /* ----------------------------------------
     Copy link (clipboard API with fallback)
  ----------------------------------------- */
  if (copyBtn) {
    copyBtn.addEventListener("click", async () => {
      try {
        await copyText(`My exam timetable:\n${window.location.href}`);

        copyBtn.innerHTML = "Copied!";
        setTimeout(() => {
          copyBtn.innerHTML = `<i class="bi bi-link-45deg" aria-hidden="true"></i> Copy link`;
        }, 1500);
      } catch {
        alert("Copy failed — please copy manually.");
      }
    });
  }
  /* ----------------------------------------
     Copy table (clipboard API with fallback)
  ----------------------------------------- */
  if (copyTableBtn) {
    copyTableBtn.addEventListener("click", async () => {
      if (!selected.length) {
        alert("Please select at least one exam");
        return;
      }

      const text = selected
        .map(
          (
            e,
          ) => `${e.examCode} — ${e.examTitle}${e.componentName ? `\n${e.componentName}` : ``}
${e.examDateRaw} ${e.examTime} — ${e.examLocation ?? "TBC"}`,
        )
        .join("\n\n");

      try {
        await copyText(text);

        copyTableBtn.innerHTML = "Copied!";
        setTimeout(() => {
          copyTableBtn.innerHTML = `<i class="bi bi-clipboard" aria-hidden="true"></i> Copy timetable`;
        }, 1500);
      } catch {
        alert("Copy failed — please copy manually.");
      }
    });
  }

  console.log({
    copyBtn,
    copyTableBtn,
  });
  /* ----------------------------------------
     Helpers
  ----------------------------------------- */
  function formatDateTime(date) {
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  function getUniqueModules(rows) {
    const seen = new Set();

    return rows.filter((exam) => {
      if (seen.has(exam.examCode)) return false;
      seen.add(exam.examCode);
      return true;
    });
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    // fallback for HTTP / older browsers
    return new Promise((resolve, reject) => {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed"; // avoid scroll jump
      textarea.style.opacity = "0";

      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();

      try {
        const success = document.execCommand("copy");
        document.body.removeChild(textarea);
        success ? resolve() : reject();
      } catch (err) {
        document.body.removeChild(textarea);
        reject(err);
      }
    });
  }

  function getFromQuery() {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get("exams");
    if (!raw) return [];

    const codes = raw.split(",").map((c) => c.trim());

    return exams.filter((e) =>
      codes.some((code) => {
        const base = code.split(" ")[0]; // strip "(SUMMER)" etc
        return e.examCode === base;
      }),
    );
  }

  function updateActions() {
    const disabled = selected.length === 0;
    copyBtn.disabled = disabled;
    copyTableBtn.disabled = disabled;
  }

  function updateQuery() {
    const codes = selected.map((e) => e.examCode);

    const url = new URL(window.location.href);

    if (codes.length) {
      url.searchParams.set("exams", codes.join(","));
    } else {
      url.searchParams.delete("exams");
    }

    window.history.replaceState({}, "", url);
  }

  /* function uniquePush(arr, item) {
    if (!arr.find((x) => x.examCode === item.examCode)) {
      arr.push(item);
    }
  } */

  function addModuleSelection(arr, item) {
    // If this module is already selected, do not add it again
    if (arr.some((x) => x.examCode === item.examCode)) {
      return;
    }

    // Add every exam row for this module code
    exams
      .filter((exam) => exam.examCode === item.examCode)
      .forEach((exam) => {
        arr.push(exam);
      });
  }

  function formatDate(date) {
    if (!date) return "—";

    const d = new Date(date);

    if (Number.isNaN(d.getTime())) return "—";

    return d.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  function formatDisplayDate(raw) {
    if (!raw) return "—";

    // Expected source format: dd/mm/yyyy
    const parts = String(raw).split("/");
    if (parts.length !== 3) return raw;

    const [day, month, year] = parts.map((part) => part.trim());

    const date = new Date(Number(year), Number(month) - 1, Number(day));

    if (Number.isNaN(date.getTime())) return raw;

    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  }

  function clearSuggestions() {
    suggestions = [];
    activeIndex = -1;
    suggestionsEl.innerHTML = "";
    input.setAttribute("aria-expanded", "false");
  }

  function setActive(index) {
    activeIndex = index;
    const items = suggestionsEl.querySelectorAll("li[role='option']");
    items.forEach((li, i) => {
      li.classList.toggle("is-active", i === activeIndex);
      li.setAttribute("aria-selected", i === activeIndex ? "true" : "false");
    });
  }

  function renderSuggestions(list, message = "") {
    if (!list.length && !message) {
      clearSuggestions();
      return;
    }

    input.setAttribute("aria-expanded", "true");

    const resultItems = list
      .map(
        (e, i) => `
        <li role="option" data-index="${i}">
          <strong>${escapeHtml(e.examCode)}</strong>
          <span class="examtrack-ui__sublabel"> — ${escapeHtml(
            e.examTitle,
          )}</span>
        </li>
      `,
      )
      .join("");

    const messageItem = message
      ? `
        <li class="examtrack-ui__suggestions-message" aria-hidden="true">
          ${escapeHtml(message)}
        </li>
      `
      : "";

    suggestionsEl.innerHTML = resultItems + messageItem;

    setActive(-1);
  }

  function renderTags() {
    const modules = getUniqueModules(selected);

    tagsEl.innerHTML = modules
      .map(
        (e) => `
      <span class="tag">
        ${escapeHtml(e.examCode)}
        <button aria-label="Remove ${escapeHtml(
          e.examCode,
        )}" data-code="${escapeHtml(e.examCode)}">×</button>
      </span>
    `,
      )
      .join("");
  }

  function sortExams(rows) {
    return [...rows].sort((a, b) => {
      const d = a.examDate.localeCompare(b.examDate);
      if (d !== 0) return d;
      return a.examTime.localeCompare(b.examTime);
    });
  }

  function renderRows(rows) {
    if (!rows.length) {
      tbody.innerHTML = "";
      empty.style.display = "block";
      return;
    }
    empty.style.display = rows.length ? "none" : "block";

    // sort by date then time
    const sorted = [...rows].sort((a, b) => {
      const d = a.examDate.localeCompare(b.examDate);
      if (d !== 0) return d;
      return a.examTime.localeCompare(b.examTime);
    });

    tbody.innerHTML = sorted
      .map(
        (e) => `
      <tr>
        <td>${escapeHtml(formatDisplayDate(e.examDateRaw))}</td>
        <td>${escapeHtml(e.examTime)}</td>
        <td class="examtrack-ui__code">${escapeHtml(e.examCode)}</td>
        <td class="examtrack-ui__exam-title">
          ${escapeHtml(e.examTitle)}
        </td>
        <td class="examtrack-ui__exam-component">
          ${e.componentName ? escapeHtml(e.componentName) : "—"}
        </td>
        <td>${escapeHtml(e.examLocation ?? "—")}</td>
      </tr>
    `,
      )
      .join("");
  }

  function applySelection() {
    renderTags();
    renderRows(selected);

    input.placeholder = selected.length
      ? "Add another module code…"
      : "Enter module code…";

    addMoreHint.hidden = selected.length === 0;

    // 🔥 SHOW / HIDE RESULTS
    if (selected.length > 0) {
      resultsEl.hidden = false;
    } else {
      resultsEl.hidden = true;
    }
    updateActions();
    updateQuery();
  }

  function pickSuggestion(index) {
    const exam = suggestions[index];
    if (!exam) return;

    addModuleSelection(selected, exam);

    input.value = "";
    clearSuggestions();
    applySelection();
    input.focus();
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  /* ----------------------------------------
     Initial render (restore selection)
  ----------------------------------------- */

  renderTags();
  renderRows(selected);

  if (selected.length > 0) {
    resultsEl.hidden = false;
  }

  updateActions();

  /* ----------------------------------------
     Typeahead (limit + exclude selected)
  ----------------------------------------- */
  input.addEventListener("input", (e) => {
    const q = e.target.value.toLowerCase().trim();

    if (!q) {
      clearSuggestions();
      return;
    }

    if (q.length < 6) {
      suggestions = [];
      activeIndex = -1;

      renderSuggestions(
        [],
        `Please enter at least 6 characters of your module code.`,
      );

      return;
    }

    const selectedCodes = new Set(selected.map((s) => s.examCode));

    const allMatches = getUniqueModules(
  exams.filter((exam) => {
    const code = (exam.examCode || "").toLowerCase();

    return !selectedCodes.has(exam.examCode) && code.startsWith(q);
  }),
).sort((a, b) => {
  const aCode = (a.examCode || "").toLowerCase();
  const bCode = (b.examCode || "").toLowerCase();

  const score = (code) => {
    if (code === q) return 0;
    if (code.startsWith(q)) return 1;
    return 2;
  };

  return score(aCode) - score(bCode) || aCode.localeCompare(bCode);
});

    suggestions = allMatches.slice(0, 6);

    renderSuggestions(
      suggestions,
      allMatches.length > suggestions.length
        ? "Showing the best 6 matches. Keep typing to narrow your search."
        : "",
    );
  });

  /* ----------------------------------------
     Mouse selection
  ----------------------------------------- */

  suggestionsEl.addEventListener("click", (e) => {
    const li = e.target.closest("li");
    if (!li) return;
    const index = Number(li.dataset.index);
    pickSuggestion(index);
  });

  /* ----------------------------------------
     Keyboard navigation
     ↑ ↓ Enter Esc
  ----------------------------------------- */

  input.addEventListener("keydown", (e) => {
    const count = suggestions.length;
    if (!count) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      const next = activeIndex < count - 1 ? activeIndex + 1 : 0;
      setActive(next);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      const prev = activeIndex > 0 ? activeIndex - 1 : count - 1;
      setActive(prev);
    } else if (e.key === "Enter") {
      if (activeIndex >= 0) {
        e.preventDefault();
        pickSuggestion(activeIndex);
      }
    } else if (e.key === "Escape") {
      clearSuggestions();
    }
  });

  /* ----------------------------------------
     Remove tag
  ----------------------------------------- */

  tagsEl.addEventListener("click", (e) => {
    const btn = e.target.closest("button");
    if (!btn) return;
    const code = btn.dataset.code;
    selected = selected.filter((e) => e.examCode !== code);
    applySelection();
  });

  /* ----------------------------------------
     Clear all
  ----------------------------------------- */

  clearBtn.addEventListener("click", () => {
    selected = [];
    input.value = "";
    clearSuggestions();
    applySelection();
    input.focus();
  });
}
